export const GET_JOBS_LIST_REQUEST = 'app/jobs/GET_JOBS_LIST_REQUEST';
export const GET_JOBS_LIST_SUCCESS = 'app/jobs/GET_JOBS_LIST_SUCCESS';
export const GET_JOBS_LIST_FAILURE = 'app/jobs/GET_JOBS_LIST_FAILURE';
export const CHANGE_SORT = 'app/jobs/CHANGE_SORT';
export const CHANGE_CURRENT_PAGE = 'app/jobs/CHANGE_CURRENT_PAGE';
